import React from "react";
import { Link } from "react-router-dom";

export default function HotJobComponent(props) {
  const { path = "", img = "" } = props;
  const { job_title, id, profile_image } = props.item;

  return (
    <div className="item">
      <div className="col-sm-12 p-2 delay-1">
        <div className="grid-view brows-job-list">
          <div className="brows-job-company-img">
            {profile_image!=="" ? (
              <img
                src={path + encodeURI(profile_image)}
                className="img-responsive"
                alt={job_title}
              />
            ) : (
              <img src={img} className="img-responsive" alt={job_title} />
            )}
          </div>
          <div className="brows-job-position">
            <h3>
              <Link to={`/job-detail/${id}`}>{job_title}</Link>
            </h3>
          </div>
          <br />
          <Link
            to={`/job-detail/${id}`}
            className="genric-btn info circle arrow"
          >
            View Job
            <span className="lnr lnr-arrow-right" />
          </Link>
          <br />
          <br />
        </div>
      </div>
    </div>
  );
}
